<template>
    <div>
        <div class="logout-container"
             :class="{'verify': verify}">
            <div class="logout-content un-login"
                 v-if="(code == '3001004' || code == '105') && !verify">
                <div class="verify-ctrl">
                    <span class="transform-center">
                        <el-button type="primary"
                                   @click="goToVerify"
                                   size="small">不登录验签</el-button>
                        <span class="entry-text">政府部门印章管理<a class="red-text"
                               href="http://10.85.250.37:9080"
                               target="_blank">入口</a></span>
                    </span>
                    <span>
                        <a class="red-text"
                           href="/qyswebapp/assets/js/vendor/help.pdf"
                           download="上海市电子印章公共服务平台-用户操作手册V2.0.pdf">下载用户使用手册</a>
                        登录后体验所有功能</span>
                </div>
                <h3 class="text-center header-content">
                    电子印章简介
                </h3>
                <el-collapse v-model="active"
                             @change="handleChange"
                             accordion>
                    <el-collapse-item v-for="(item, index) in imageSet"
                                      :key="index"
                                      :title="item.title"
                                      :name="index">
                        <img v-for="(img, key) in item.images"
                             :key="key"
                             class="decription-img"
                             :src="img">
                    </el-collapse-item>
                </el-collapse>
            </div>

            <div v-if="code == '3001002'"
                 class="logout-content text-center">
                <h3>您当前还未绑定手机号，
                    绑定手机后才可使用电子印章</h3>
                <p class="ctrl">请前往<a class="red-text"
                       @click="jumpPage">一网通个人中心</a>办绑定</p>
            </div>

            <div v-if="code == '3001001'"
                 class="logout-content text-center">
                <h3>用户等级过低</h3>
                <p class="tip">请提升实名等级到中级后再使用电子印章服务</p>
                <p class="ctrl">请前往<a class="red-text"
                       @click="jumpPage">一网通个人中心</a>办升级</p>
            </div>

            <div v-if="code == '3001005'"
                 class="logout-content text-center">
                <h3>电子营业执照目前仅支持上海地区企业使用电子印章，外地企业请使用法人一证通Ukey登录</h3>
            </div>
            <div v-else-if="code == '3001006'"
                 class="logout-content text-center">
                <h3>该ukey设备不允许登录</h3>
            </div>

            <div class="verify-page"
                 v-if="verify">
                <div class="header">
                    <el-button class="grey-text small-font"
                               type="text"
                               @click="verify = false">&lt; 返回上一页</el-button>
                </div>
                <verify-upload url="/verify/notlogin"
                               is-unlogin></verify-upload>
            </div>
        </div>

        <div class="fixed-container">
            <a class="red-text"
               href="http://10.85.250.37:9080"
               target="_blank">政府部门印章管理入口</a>
        </div>
    </div>
</template>

<script>
import VerifyUpload from './verify/childs/verify-upload.vue';
import { mapGetters } from 'vuex';
// import PageContainer from "../components/container.vue";

export default {
    components: { VerifyUpload },
    data () {
        return {
            active: '',
            verify: false
        };
    },
    computed: {
        ...mapGetters(['system']),
        title () {
            let titles = new Map([
                [3001001, '用户等级过低'],
                [3001002, '用户没有绑定手机号'],
                [3001004, ''],
                [3001005, '电子营业执照目前仅支持上海地区企业使用电子印章，外地企业请使用法人一证通Ukey登录'],
                [3001006, '该ukey设备不允许登录'],
            ]);
            return this.code ? '' : titles.get(this.code);
        },
        imageSet () {
            const { areaType } = this.system;
            // 如果没有集成的地区使用默认的图片
            const filePath = ['MHQ'].includes(areaType) ? `${areaType}/` : '';
            return [
                {
                    title: '一、什么是电子印章',
                    images: [
                        require('../assets/images/login/1-1.jpg'),
                        require('../assets/images/login/1-2.jpg'),
                    ]
                },
                {
                    title: '二、电子印章有法律效力吗',
                    images: [
                        require('../assets/images/login/2-1.jpg'),
                    ]
                },
                {
                    title: '三、电子印章的优势',
                    images: [
                        require('../assets/images/login/3-1.jpg'),
                        require('../assets/images/login/3-2.jpg'),
                        require('../assets/images/login/3-3.jpg'),
                        require('../assets/images/login/3-4.jpg'),
                    ]
                },
                {
                    title: '四、上海市电子印章公共服务平台的使用条件',
                    images: [
                        require('../assets/images/login/4-1.jpg'),
                    ]
                },
                {
                    title: '五、如何申领和管理',
                    images: [
                        require(`../assets/images/login/${filePath}5-1.jpg`),
                        require('../assets/images/login/5-2.jpg'),
                        require(`../assets/images/login/${filePath}5-3.jpg`),
                    ]
                },
                {
                    title: '六、如何使用电子印章签署',
                    images: [
                        require(`../assets/images/login/${filePath}6-1.jpg`),
                        require('../assets/images/login/6-2.jpg'),
                    ]
                },
                {
                    title: '七、如何验证签署有效性',
                    images: [
                        require(`../assets/images/login/${filePath}7-1.jpg`),
                        require(`../assets/images/login/${filePath}7-2.jpg`),
                        require('../assets/images/login/7-3.jpg'),
                        require('../assets/images/login/7-4.jpg'),
                        require('../assets/images/login/7-5.jpg'),
                    ]
                },
            ];
        },
        // 登录状态
        code () {
            // 3001001  用户等级过低
            // 3001002  用户没有绑定手机号
            // 3001004  用户未登录
            return this.$route.query.code;
        },
        isProduct () {
            return this.$store.getters.system.env === 'production';
        },

        redirectHost() {
            return this.isProduct ? 'https://zwdtuser.sh.gov.cn' : 'http://117.184.226.149:8080';
        },
    },

    methods: {
        goToVerify () {
            this.verify = true;
        },
        handleChange (index) {
            this.active = index;
        },
        jumpPage () {
            window.top.location.href = this.redirectHost + '/uc/naturalUser/jump.do?redirect_uri=https://zwdt.sh.gov.cn/smzy/shspace/loginsso/in?targetUrl=smzy18';
        }
    }
};
</script>

<style lang="less" scoped>
.logout-container {
    .header {
        padding: 20px 20px 0;
    }
    a {
        cursor: pointer;
    }
    .header-content {
        margin: 30px 0 60px;
        padding: 20px;
        position: relative;
    }
}
</style>

<style lang="less">
.logout-container {
    width: 800px;
    min-height: 660px;
    flex: 1;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    @keyframes identifier {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }

    .entry-text {
        display: flex;
        margin-left: 20px;
        font-size: 14px;
        color: #999;
        a {
            display: block;
            text-decoration: underline;
            animation: identifier 1s infinite ease-out;
        }
    }

    &.verify {
        width: 1100px;
    }

    .logout-content {
        width: 800px;
        margin-bottom: 40px;
        position: relative;

        &.un-login {
            min-height: 660px;
        }
        .el-collapse {
            border-bottom: 1px solid @border-color-base;
        }
        .el-collapse-item {
            .el-collapse-item__header {
                position: relative;
                height: auto;
                padding-left: 0;
                border-bottom: 0;
                border-top: 1px solid @border-color-base;
                font-weight: 700;
                font-size: 16px;
                padding: 0 20px;
                color: #383838;
                letter-spacing: 0.1px;

                &.is-active {
                    background: linear-gradient(
                        to right,
                        @red,
                        @white
                    ) !important;
                    background-repeat: no-repeat;
                    background-position: 0 0;
                    background-size: 100% 92px;
                }
            }
        }

        .decription-img {
            width: 80%;
            margin: 20px auto;
        }

        .ctrl {
            display: block;
            margin: 20px auto 0;
        }

        .tip {
            margin-top: 10px;
        }
    }

    .verify-page {
        height: 600px;
        width: 100%;
    }

    .verify-ctrl {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
    }
}
.fixed-container {
    position: fixed;
    top: 50%;
    left: 0;
    text-align: center;
    width: 120px;
    height: auto;
    padding: 30px 8px;
    background: #fdeee3;
    text-shadow: 1px 1px 0px @white, -1px -1px 0px @white, 2px 2px 0px @white,
        -2px -2px 0px @white, 3px 3px 0px @white, -3px -3px 0px @white;
    box-shadow: 1px 1px 5px #998;
    font-size: 20px;
    font-weight: bold;
    color: @primary;
    border-radius: 0 20px 20px 0;
    transition: 0.3s all;
    a {
        cursor: pointer;
    }
}
</style>
